module.exports = __webpack_public_path__ + "static/media/image7.7bd82b7c.png";